"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HistoryRequestDetails {
    constructor(sessionId, messageLimit = 0, includeRevertedEntries = false) {
        this.sessionId = sessionId;
        this.messageLimit = messageLimit;
        this.includeRevertedEntries = includeRevertedEntries;
    }
}
exports.default = HistoryRequestDetails;
//# sourceMappingURL=HistoryRequestDetails.js.map


// WEBPACK FOOTER //
// ../../../Alme/V6/HistoryRequestDetails.ts